import React from 'react'

import * as c from '../../../common'
import * as common from '../../../common'

import * as r from '../../../react-utils'

import * as Mui from '@mui/material'
import * as MuiIcons from '@mui/icons-material'

import * as cpm from '../../../app/components'
import * as gs from '../../../app/gStyles'
import * as milieu from '../../milieu'
import Pad from '../Pad'

import ContractLogo from '../../routes/customer-report/ContractLogo'

//@ts-ignore
import styles from './MainPageReport.module.css'

export interface MainPageReportProps {
  customerAddress: string
  customerID: string
  customerName: string
  homeRep: string
  houseViewPic: string | undefined
  isPDF: boolean
  solarCompany: string
  solarRep: string
  sortKey: number
}

export default React.memo<MainPageReportProps>(function MainPageReport({
  customerAddress,
  customerID,
  customerName,
  homeRep,
  houseViewPic,
  isPDF,
  solarCompany,
  solarRep,
}) {
  const [open, setOpen] = React.useState(false)

  const { currProducts } = r.useProducts(customerID)

  const [reportCompanySignatureDate] = r.useCustomerField(
    customerID,
    'report_company_signature_date',
  )

  const { contractCompanyFull, shouldOfferCompanySelector } =
    r.useContractCompany(customerID)

  const handleTooltipClose = React.useCallback(() => {
    setOpen(false)
  }, [setOpen])

  const handleTooltipOpen = React.useCallback(() => {
    setOpen(true)
    navigator.clipboard.writeText(customerID)
    setTimeout(() => {
      setOpen(false)
    }, 1800)
  }, [customerID, setOpen])

  const padCompanyStyle = React.useMemo((): React.CSSProperties => {
    return {
      backgroundColor: common.companyColors[solarCompany],
      height: '20px',
      width: '100%',
    }
  }, [solarCompany])

  const brandCompanyStyle = React.useMemo((): React.CSSProperties => {
    return {
      color: common.companyColors[solarCompany],
      fontSize: '36px',
      fontWeight: '700',
      margin: 0,
    }
  }, [solarCompany])

  const dataTitleCompanyStyle = React.useMemo((): React.CSSProperties => {
    return {
      color: common.companyColors[solarCompany],
      fontSize: '18px',
      fontWeight: '700',
      margin: 0,
      textTransform: 'capitalize',
    }
  }, [solarCompany])

  return (
    <div className={styles['container']}>
      <img
        alt="Customer's house"
        className={styles['customer-house-picture']}
        src={houseViewPic || milieu.FAKE_HOUSE}
      />
      <div style={padCompanyStyle}></div>
      <Pad amt={115} />
      {/* MAIN DATA */}
      <div className={styles['main-data']}>
        {/* COMPANY BRANDS */}
        <div className={styles['company-brands']}>
          <Pad amt={80} />
          {/* REPORT TITLE */}

          {(currProducts.includes('HIL') || currProducts.length === 0) && (
            <h1 style={brandCompanyStyle}>Home Improvement Contract</h1>
          )}

          {currProducts.includes('RC') && (
            <>
              {(currProducts.includes('Solar') ||
                currProducts.includes('HIL') ||
                currProducts.length === 0) &&
                titleSeparator}
              <h1 style={brandCompanyStyle}>Roof Claim</h1>
            </>
          )}

          <Pad amt={80} />

          {shouldOfferCompanySelector ? (
            <ContractLogo isPDF={isPDF} size="l" />
          ) : (
            <img
              alt="Company logotype"
              className={styles['company-logo']}
              src={milieu.companyToLogo[solarCompany]}
            />
          )}
          <Pad amt={40} />
        </div>

        {/* CUSTOMER INFO */}
        <div className={styles['customer-info']}>
          {/* CUSTOMER DATA */}
          <div className={styles['customer-data']}>
            <h3 style={dataTitleCompanyStyle}>Proposal For:</h3>
            <Pad amt={10} />
            <span className={styles['customer-data-name']}>{customerName}</span>
            <Pad amt={0.5} />
            <span className={styles['customer-data-text']}>
              {customerAddress}
            </span>
          </div>
          <Pad amt={20} />
          {/* CUSTOMER DATA */}
          <div className={styles['customer-data']}>
            <h3 style={dataTitleCompanyStyle}>Contact:</h3>
            <Pad amt={10} />
            <span className={styles['customer-data-company']}>
              {shouldOfferCompanySelector
                ? contractCompanyFull.longName
                : solarCompany}
            </span>
            {c.CODENAME !== 'nirvana' && (
              <>
                <Pad amt={5} />
                <span className={styles['customer-data-text']}>{solarRep}</span>
              </>
            )}
          </div>
          <Pad amt={20} />
          {/* CUSTOMER DATA */}
          <div className={styles['customer-data']}>
            <h3 style={dataTitleCompanyStyle}>Date Signed:</h3>
            <Pad amt={10} />
            <span className={styles['customer-data-name']}>
              {reportCompanySignatureDate
                ? c.numberToDate(reportCompanySignatureDate)
                : 'Not Signed'}
            </span>
          </div>
          <Pad amt={20} />
          {/* CUSTOMER DATA */}
          <div className={styles['customer-data']}>
            <h3 style={dataTitleCompanyStyle}>Representative:</h3>
            <Pad amt={10} />
            <span className={styles['customer-data-name']}>{homeRep}</span>
          </div>
          <Pad amt={20} />
          <div className={styles['customer-data']}>
            <h3 style={dataTitleCompanyStyle}>Customer ID</h3>
            <Pad amt={10} />
            <Mui.ClickAwayListener onClickAway={handleTooltipClose}>
              <div>
                <Mui.Tooltip
                  PopperProps={popperProps}
                  disableFocusListener
                  disableHoverListener
                  onClose={handleTooltipClose}
                  open={open}
                  placement="bottom"
                  title="Copied!"
                >
                  <div className={styles['customer-id']}>
                    <span className={styles['customer-data-id']}>
                      {customerID}
                    </span>{' '}
                    {!isPDF && (
                      <>
                        <Pad amt={10} row />
                        <MuiIcons.ContentCopy
                          onClick={handleTooltipOpen}
                          sx={sx['copyIcon']}
                        />
                      </>
                    )}
                  </div>
                </Mui.Tooltip>
              </div>
            </Mui.ClickAwayListener>
          </div>
        </div>
      </div>
    </div>
  )
})

const sx = {
  copyIcon: {
    cursor: 'pointer',
  },
}

const popperProps = {
  disablePortal: true,
}

const titleSeparator = (
  <cpm.View style={{ ...gs.rowCentered, marginVertical: 12 }}>
    <cpm.View backgroundColor={c.light.canvas.opaque} height={1} width={120} />
    {gs.colGap8}
    <cpm.Text
      style={{
        color: c.light.canvas.opaque,
        fontFamily: c.light.canvas.fontFamily,
        fontSize: 12,
      }}
    >
      &
    </cpm.Text>
    {gs.colGap8}
    <cpm.View backgroundColor={c.light.canvas.opaque} height={1} width={120} />
  </cpm.View>
)
